export const environment = {
    production: true,
    socialscanApiUrl: 'https://api.socialscan.io',
    telegram: {
        id: 5570182086,
        botLink: 'https://t.me/socialscan_meme_hunter_bot',
        socialScanBotLink: 'https://t.me/hemera_socialscan_bot',
    },
    gtag: {
        id: 'G-FF6SR4HWTH',
    },
};
